import {Mapper} from '@s-ui/domain'

export class SeoPublishMyAdMetaInformationMapper extends Mapper {
  constructor({config, seoDataValueObjectFactory, seoDataMapper, seoLiteralMapper}) {
    super()

    this._config = config
    this._seoDataValueObjectFactory = seoDataValueObjectFactory
    this._seoDataMapper = seoDataMapper
    this._seoLiteralMapper = seoLiteralMapper
  }

  _buildCanonical = () => {
    const protocol = this._config.get('URL_PROTOCOL')
    const host = this._config.get('HOST_DOMAIN')
    const {PUBLISH_MY_AD_PATH_PATTERN} = this._config.get('page')

    return `${protocol}${host}${PUBLISH_MY_AD_PATH_PATTERN}`
  }

  async map({culture}) {
    const {publishMyAd: publishMyAdConfig} = this._config.get('seo')
    const {H1, TITLE, META_DESCRIPTION, META_ROBOTS} = publishMyAdConfig[culture]

    const canonical = this._buildCanonical()

    const parsedTitle = this._seoLiteralMapper.setText({text: TITLE}).map()

    const parsedDescription = this._seoLiteralMapper.setText({text: META_DESCRIPTION}).map()

    const {links, metas, scripts, title} = this._seoDataMapper
      .title(parsedTitle)
      .description(parsedDescription)
      .robots(META_ROBOTS)
      .canonical(canonical)
      .setOpenGraphData({
        title: parsedTitle,
        description: parsedDescription,
        url: canonical
      })
      .setTwitterCardsData()
      .map()

    return this._seoDataValueObjectFactory({
      h1: H1,
      head: {
        link: links,
        meta: metas,
        scripts,
        title
      }
    })
  }
}
